module.exports = __webpack_public_path__ + "img/dl-left4.ec469ce1.gif";